<div class="w-full mb-12 px-2 sm:px-0 relative">
  <div class="relative max-w-4xl mx-auto">
    <!-- Background Line -->
    <div class="absolute top-3 left-10 right-10 h-0.5 bg-gray-300 -z-0"></div>

    <!-- Active Progress Line -->
    <div
      class="absolute top-3 bg-blue-600 transition-all z-10 h-0.5"
      [ngStyle]="{
        left: screenWidth < 500 ? '1rem' : '2.5rem',
        width:
          screenWidth < 500
            ? 'calc(100% - 2rem)'
            : 'calc((100% - 80px) * ' + currentStep / (questions.length - 1) + ')'
      }"
    ></div>

    <div
      class="grid text-center relative"
      [ngStyle]="{
        'grid-template-columns': 'repeat(' + questions.length + ', minmax(0, 1fr))'
      }"
    >
      @for (section of questions; track $index; let i = $index) {
        <button
          type="button"
          class="flex flex-col items-center cursor-pointer bg-transparent border-0 p-0"
          (click)="goToStep(i)"
        >
          <!-- Step Circle -->
          <div
            class="w-7 h-7 md:w-6 md:h-6 sm:w-5 sm:h-5 xs:w-4 xs:h-4 rounded-full flex items-center justify-center text-xs xs:text-[4px] border-2 transition-all relative z-20"
            [ngClass]="{
              'bg-blue-500 border-blue-500 text-gray-100': i < currentStep,
              'bg-blue-600 border-blue-600 text-white': i === currentStep,
              'bg-white border-gray-300 text-gray-400': i > currentStep
            }"
          >
            {{ i + 1 }}
          </div>
        </button>
      }
    </div>

    <!-- Active Title Centered -->
    <!-- <div class="absolute bg-amber-200 left-1/2 transform -translate-x-1/2 mt-3 text-blue-600 font-semibold sx:text-xs text-sm">
      {{ questions[currentStep]?.title }}
    </div> -->
  </div>
</div>